import React from "react";
import { BrowserRouter } from "react-router-dom";
// import { HashRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

import App from "./App";
import ScrollToTop from "./utils/ScrollToTop";

// Data and context
import WebplaceProvider from "./store/webplace-provider";

import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <HashRouter>
  <BrowserRouter>
    <WebplaceProvider>
      <ScrollToTop />
      <App />
    </WebplaceProvider >
  </BrowserRouter>
  // </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
